<template>
  <!--横向列表区块 开始-->
  <div class="application clearfix bottom-switch">
    <template v-for="(item,ind) in listData">
      <div class="application-box fl"
           :key="ind"
           v-if="ind<6"
           @click="$emit('emitHandleDetail',item)"
           @contextmenu.stop.prevent="item.others[0].standardData?$emit('emitContextMenuItem',ind,$event):''"
           @touchstart="touchstarts(ind)"
           @touchmove="touchmoves()"
           @touchend="touchends()">
        <a href="javascript:;">
          <div class="audit">
            <ZImage :value="item.pictures[0]?item.pictures[0]:''"
                    :error-src="require('../../assets/image/images/default_media.png')" />
          </div>
          <div class="character">
            <div class="name">{{item.others[0].standardData?item.others[0].standardData:''}}</div>
            <div class="information clearfix">
              <div class="price">
                <span>{{item.id?(item.others[1]?(item.others[1].standardName?item.others[1].standardName+':':''):''):''}}</span>
                <span> {{item.id?(item.others[1]?(item.others[1].standardData?(allPrice(item.others[1].standardEnName) ? formatPrice(item.others[1].standardData) : item.others[1].standardData):''):''):''}}</span>
              </div>
              <div class="price">
                <span>{{item.id?(item.others[2]?(item.others[2].standardName?item.others[2].standardName+':':''):''):''}} </span>
                <span> {{item.id?(item.others[2]?(item.others[2].standardData?item.others[2].standardData:''):''):''}}</span>
              </div>
            </div>
            <div class="information clearfix">
              <div class="price">
                <span>{{item.id?(item.others[3]?(item.others[3].standardName?item.others[3].standardName+':':''):''):''}} </span>
                <i> {{item.id?(item.others[3]?(item.others[3].standardData?item.others[3].standardData:''):''):''}}</i>
              </div>
            </div>
          </div>
        </a>
      </div>
    </template>
  </div>

  <!--横向列表区块 结束-->
</template>
<script>
import ZImage from "../ZImage.vue"
export default {
  name: 'enterpris',
  components: {
    ZImage
  },
  props: {
    listData: {
      type: Array
    }
  },
  data () {
    return {
      timeOutEvent: 0
    }
  },
  methods: {
    touchstarts (ind) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.$emit('emitContextMenuItem', ind);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmoves () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchends (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
  }
}

</script>
<style scoped>
.application {
  height: 326px;
  overflow: hidden;
  padding: 18px 20px 28px 20px;
}
.application .application-box {
  width: calc(50% - 41px);
  height: 69px;
  margin: 5px;
  margin-bottom: 10px;
  border: 1px solid #dddddd;
  padding: 17px;
  overflow: hidden;
}
.application .application-box .audit {
  width: 70px;
  height: 70px;
  border-radius: 4px;
  overflow: hidden;
  float: left;
  text-align: center;
}
.application .application-box .audit img {
  width: 100%;
  height: 100%;
}

.application .application-box .character {
  width: 394px;
  width: calc(100% - 88px);
  margin-left: 16px;
  float: left;
  overflow: hidden;
}
.application .application-box .character .name {
  font-size: 18px;
  color: #333333;
  height: 18px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.application .application-box .character .name a {
  color: #333333;
}
.application .application-box .character .information {
  font-size: 14px;
  color: #666;
  margin-top: 8px;
  height: 20px;
  overflow: hidden;
}
.application .application-box .character .information span {
  font-size: 14px;
}
.application .application-box .character .information .price {
  min-width: 128px;
  max-width: 50%;
  float: left;
  margin-right: 3px;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.application .application-box .character .information .price i {
  color: #2f8eed;
  font-size: 14px;
}
.application .application-box .character .information .price:last-child {
  margin-right: 0px;
}
.application .application-box:nth-child(2n-1) {
  margin-top: 0;
  margin-left: 0;
}
.application .application-box:nth-child(2n) {
  margin-top: 0;
  margin-right: 0;
}
</style>>



// WEBPACK FOOTER //
// src/components/floorBlock/horizontal_list.vue